/**
 * Profil ve Ayarlar ekranlarının metinleri.
 *
 * İki ekran da **gerçek**: profil, oturumu açık kullanıcının uçtan gelen kendi kaydını
 * gösteriyor; ayarlar, iki temanın arasında seçim yaptırıyor ve seçimi saklıyor. Menüye
 * "yakında" yazan bir madde konmadı, çünkü kullanılamayan bir menü maddesi kullanıcıya
 * yalan söyler.
 */
export const HESAP_METIN = {
  profil: {
    ustBaslik: 'OTURUM',
    baslik: 'Profil',
    tarif: 'Bu ekran uçtan gelen kendi kaydınızı gösteriyor; buradan değiştirilemez.',
    ad: 'Görünen ad',
    kullaniciKimligi: 'Kullanıcı kimliği',
    rol: 'Rol',
    rolKodu: 'Rol kodu',
    kodNotu: 'Kod değeri veritabanında böyle duruyor; ekranda karşılığı yazılıyor.',
    yetkiler: 'Yetkiler',
    yetkiSayisi: (adet: string) => `${adet} yetki`,
    yetkiYok: 'Bu role hiçbir yetki tanımlanmamış.',
    parolaBaslik: 'Parolayı değiştir',
    parolaTarif: 'Eski parolanı yazman gerekir. Değişince diğer cihazlardaki oturumların kapanır, burası açık kalır.',
    parolaMevcut: 'Mevcut parola',
    parolaYeni: 'Yeni parola',
    parolaTekrar: 'Yeni parolayı tekrar yaz',
    parolaKural: 'En az 12 karakter. Kolay tahmin edilen parolalar, adın ve e-postan kabul edilmez.',
    parolaUyusmuyor: 'İki yeni parola aynı değil.',
    parolaKaydet: 'Parolayı değiştir',
    parolaKaydediliyor: 'Değiştiriliyor…',
    parolaHata: 'Parola değiştirilemedi.',
    parolaTamam: (adet: number) => `Parolan değişti. Diğer cihazlardaki ${adet} oturum kapatıldı.`,
  },
  ayarlar: {
    ustBaslik: 'TERCİHLER',
    baslik: 'Ayarlar',
    temaBaslik: 'Tema',
    temaTarif:
      'Seçim bu tarayıcıda saklanıyor, hesabınıza yazılmıyor. Başka bir bilgisayarda yeniden seçmeniz gerekir.',
    temaSistem: 'İşletim sistemine uy',
    temaAcik: 'Açık',
    temaKaranlik: 'Karanlık',
    temaEtiketi: 'Tema seçimi',
  },
} as const;
